import * as React from 'react';
import LocalizedStrings from "react-localization";

const Consts = new LocalizedStrings ({
    en: {
        readMore: "Read more",
        readMoreAbout: "Read more about",
        showMore: "Show more",
        moreInfo: "More info",
        moreInfoAbout: "More info on",
        close: "Close",
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        play: "Play",
        stop: "Stop",
        openInNewWindow: "Opens in a new tab",
        dateCulture: "en-US",
        more: "More",
        languages: "Language",
        share: "Open share list",
        name: "Name",
        email:"Email",
        phone: "Phone",
        message: "Message",
        send: "Send",
        invalidCharactersName: "The name is not valid. You can use only letters, and those characters: . ,:'\ %$;\-\"",
        invalidCharactersEmail: "The email is not valid. Example of a valid email: example@gmail.com ",
        invalidCharactersPhone: "The telephone number is not valid. You can use from 7 to 20 of those characters: +- 0-9  ",
        invalidCharactersMessage: "The message is not valid. You can use only letters, and those characters: ?!. ,:'\ %$;\-@()*/\"\"\=&",
        requiredField: "Required to fill the field ",
        requiredMessage: "Fields marked with an asterisk (*) are required",
        sendSuccessMsg: "We got your message, Thank you!",
        sendErrorMsg: "Please send your message again.",
        wait: "Loading…",
        accessibility: "Accessibility statement",
        accessibilityUrl: "https://www.gov.il/en/Departments/General/accessibility-statement",
        days: "Days",
        minutes: "Minutes",
        hours: "Hours",
        seconds: "Seconds",
        moreDetails: "More Details",
        googleCalendar: "Save on Google Calendar",
        outlook: "Download Outlook meeting file",
        googleMap: "Navigation with Google Maps",
        waze: "Navigation with Waze",
        search: "Search",
        searchTerm: "Search results for",
        searchResult: "Search Results",
        nosearchResult: "No search results were found",
        skipToMainContent: "Skip to main content",
        componentSearch: "Search for a word, topic, or subject freely ",
        openWhatsappChat: "Open whatsapp chat in a new tab",
        openTeamsChat: "Open teams chat in a new tab",
        chooseLang: "Choose language",
        openNavigation: "Open Navigation",
        jumpForward: "Previous page",
        jumpBackward: "Next page",
        page: "Page",
        currentPage: "is your current page",
        clean: "clean",
        searchTyped: "Type here",
        pastEvent: "The event is over, see you at the next events",
        alphonSearch: "Contact Search ",
        closeEvents: "Upcoming Events",
        backToUpcomingEvents: "Back to upcoming events",
        backToEventCalendar: "Back To Event Calendar",
        noEventsThisYear: "There're no upcoming events",
        eventsCalendar: "Events calendar",
        eventHour: "Event hour",
        eventLocation: "Event location",
        eventDescription: "Event description",
        saveInGoogleCalendar: "Save in Google Calendar",
        forNextMonth: "Next month",
        forPreviousMonth: "Previous month",
        calendarAccessibilityMsg: "By clicking on a day in the calendar, the events on that day will be displayed",
        eventsOf: "Events of ",
        callPhoneNumber: "Call Phone Number:",
        resetFilters: "Reset Filters",
        resaultsFound: "{number} results found",
        showResults: "Show Results",
        clearEverything: "Clear everything",
        selectFilter: "Select Filter",
        removeFromFilters: "Remove {filterValue} from filters",
        openFiltersSelection: "open filters selection",
        weAreHere: "We are here",
        apiFetchErrorMsg: "The data cannot be viewed at the moment, please try again later",
        noResultsAtTheTime: "No results were found at this time",
        invalidVariableInput: " is not valid. You can use only letters, and those characters: ?!. ,:'\ %$;\-@()*/\"\"\=&",
        value: "Value",
        category: "Category",
        chartTabularRepresentation: "A tabular representation of the data in the chart.",
        noDataAvailable: "No data available",
        copyLink: "Copy Link",
        copied: "Copied"
    },
    he: {
        readMore: "קרא עוד",
        readMoreAbout: "קרא עוד על",
        showMore: "הצג עוד",
        moreInfo: "מידע נוסף",
        moreInfoAbout: "מידע נוסף על",
        close: "סגירה",
        prevSlideMessage: 'הקודם',
        nextSlideMessage: 'הבא',
        play: "הפעל",
        stop: "עצור",
        openInNewWindow: "נפתח בטאב חדש בדפדפן",
        dateCulture: "he-IL",
        more: "עוד",
        languages: "שפה",
        share: "פתיחה של רשימת אפשרויות לשיתוף",
        name: "שם",
        email: "דוא\"ל",
        phone: "טלפון",
        message: "תוכן הפנייה",
        send: "שליחה",
        invalidCharactersName: "השם שהזנת לא תקין. יש להזין רק אותיות, ואת הסימנים .,:'-\" % $",
        invalidCharactersEmail: "כתובת הדואר האלקטרוני שהזנת לא תקינה. יש להזין  כתובת דוא\"ל בתבנית: example@gmail.com",
        invalidCharactersPhone: "מספר הטלפון לא תקין. יש להזין בין 7 ל-20 ספרות או הסימנים +-",
        invalidCharactersMessage: "תוכן הפניה לא תקין. ניתן להזין רק אותיות, ואת הסימנים .,?!:'-\",% $",
        requiredField: "חובה למלא שדה ",
        requiredMessage: "שדות המסומנים בכוכבית (*) הם שדות חובה",
        sendSuccessMsg: "ההודעה נשלחה בהצלחה",
        sendErrorMsg: "ההודעה לא נשלחה, יש לנסות שוב",
        wait: "עוד רגע...",
        accessibility: "הצהרת נגישות",
        accessibilityUrl: "https://www.gov.il/he/Departments/General/accessibility-statement",
        days: "ימים",
        minutes: "דקות",
        hours: "שעות",
        seconds: "שניות",
        moreDetails: "פרטים נוספים",
        googleCalendar: "שמירת האירוע ביומן גוגל",
        outlook: "הורדת קובץ זימון של יומן אאוטלוק",
        googleMap: "ניווט עם מפות גוגל",
        waze: "נווט עם Waze",
        search: "חיפוש",
        searchTerm: "תוצאות חיפוש עבור",
        searchResult: "תוצאות",
        nosearchResult: "לא נמצאו תוצאות",
        skipToMainContent: "דלג לתוכן העמוד",
        componentSearch: "חיפוש מילה, נושא או ערך באופן חופשי ",
        openWhatsappChat: "פתח צ'אט בווטסאפ בטאב חדש",
        openTeamsChat: "פתח צ'אט בטימס בטאב חדש",
        chooseLang: "בחר שפה",
        openNavigation: "פתח ניווט",
        jumpForward: "עמוד הבא",
        jumpBackward: "עמוד קודם",
        page: "עמוד",
        currentPage: "הוא הדף הנוכחי שלך",
        clean: "ניקוי",
        searchTyped: "הקלידו כאן",
        pastEvent: "האירוע הסתיים, נתראה באירועים הבאים",
        alphonSearch: "חיפוש איש קשר ",
        closeEvents: "אירועים קרובים",
        backToUpcomingEvents: "חזרה לאירועים קרובים",
        backToEventCalendar: "חזרה ליומן אירועים",
        noEventsThisYear: "לא נמצאו אירועים",
        eventsCalendar: "יומן אירועים",
        eventHour: "שעת האירוע",
        eventLocation: "מקום האירוע",
        eventDescription: "תיאור האירוע",
        saveInGoogleCalendar: "שמירה ביומן גוגל",
        forNextMonth: "לחודש הבא",
        forPreviousMonth: "לחודש הקודם",
        calendarAccessibilityMsg: "בלחיצה על יום בלוח שנה יוצגו האירועים שיש באותו יום",
        eventsOf: "אירועי ",
        callPhoneNumber: "להתקשר למספר הטלפון:",
        resetFilters: "אפס מסננים",
        resaultsFound: "נמצאו {number} תוצאות",
        showResults: "הצג תוצאות",
        clearEverything: "נקה הכל",
        selectFilter: "בחר סינון",
        removeFromFilters: "הסר את {filterValue} מהמסננים",
        openFiltersSelection: "פתח את בחירת המסננים",
        apiFetchErrorMsg: "לא ניתן לצפות כרגע בנתונים, אנא נסו שוב מאוחר יותר",
        noResultsAtTheTime: "בשלב זה לא נמצאו תוצאות",
        weAreHere: "אנחנו כאן",
        invalidVariableInput: " לא תקין. ניתן להזין רק אותיות, ואת הסימנים .,?!:'-\",% $",
        value: "ערך",
        category: "קטגוריה",
        chartTabularRepresentation: "ייצוג טבלאי של הנתונים בתרשים.",
        noDataAvailable: "אין נתונים זמינים",
        copyLink: "העתק קישור",
        copied: "הועתק"
    },
    ar: {
        readMore: "لقراءة المزيد",
        readMoreAbout: "لقراءة المزيد عن",
        showMore: "عرض المزيد",
        moreInfo: "المزيد من المعلومات",
        moreInfoAbout: "المزيد من المعلومات عن",
        close: "إغلاق",
        prevSlideMessage: 'السابق',
        nextSlideMessage: 'التالي',
        play: "تشغيل",
        stop: "وقف",
        openInNewWindow: "يفتح في علامة تبويب جديدة",
        dateCulture: "ar-ea",
        more: "المزيد",
        languages: "لغة",
        share: "مشاركة",
        name: "الاسم",
        email: "بريد إلكتروني",
        phone: "هاتف",
        message: "مضمون التوجّه",
        send: "إرسال",
        invalidCharactersName: "الاسم الذي سجّلته غير صالح. يمكن تعبئة الحروف والعلامات التالية فقط: .,:'-\"%$",
        invalidCharactersEmail: "عنوان البريد الإلكتروني الذي سجّلت غير صالح. يجب أن يكون العنوان على النحو التالي: example@gmail.com",
        invalidCharactersPhone: "رقم الهاتف الذي سجّلته غير صالح. يمكن تعبئة 7 إلى 20 الأرقام والعلامتين +- فقط",
        invalidCharactersMessage: "محتوى المراجعة غير صالح. يمكن تعبئة الحروف والعلامات التالية فقط .,?!:'-\",% $",
        requiredField: "حقل إلزامي ",
        requiredMessage: "حقول مع (*) حقول إلزامية",
        sendSuccessMsg: "تم إرسال الإشعار بنجاح",
        sendErrorMsg: "لم يُرسل الإشعار، الرجاء المحاولة مجددًا",
        wait: "لحظة من فضلك...",
        accessibility: "تصريح الإتاحة",
        accessibilityUrl: "https://www.gov.il/ar/Departments/General/accessibility-statement",
        days: "أيّام",
        minutes: "دقائق",
        hours: "ساعات",
        seconds: "ثوانٍ",
        moreDetails: "المزيد من التفاصيل",
        googleCalendar: "تقويم جوجل",
        outlook: "تقويم outlook",
        googleMap: "توجيهات القيادة بواسطة Google maps",
        waze: "توجيهات القيادة بواسطة waze",
        search: "البحث",
        searchTerm: "نتائج البحث ل",
        searchResult: "نتائج",
        nosearchResult: "لا توجد نتائج",
        skipToMainContent: "انتقلوا إلى الموقع",  
        componentSearch: "البحث عن كلمة أو موضوع  بحرية ",
        openWhatsappChat: "يفتح الواتس اب في علامة تبويب جديدة",
        openTeamsChat: "يفتح التيمس في علامة تبويب جديدة",
        chooseLang: "اختر اللغة",
        openNavigation: "Open Navigation",
        jumpForward: "الصفحة التالية",
        jumpBackward: "الصفحة السابقة",
        page: "صفحة",
        currentPage: "هي الصفحة الحالية",
        clean: "محو",
        searchTyped: "أكتب هنا",
        pastEvent: "انتهى الحدث. نراكم في الأحداث القادمة",
        alphonSearch: "Contact Search ",
        closeEvents: "أحداث قريبة",
        backToUpcomingEvents: "العودة إلى الأحداث القادمة",
        backToEventCalendar: "العودة إلى تقويم الأحداث",
        noEventsThisYear: "لا توجد أحداث",
        eventsCalendar: "تقويم الأحداث",
        eventHour: "ساعة الحدث",
        eventLocation: "مكان الحدث",
        eventDescription: "وصف الحدث",
        saveInGoogleCalendar: "حفظ في تقويم جوجل",
        forNextMonth: "الشهر القادم",
        forPreviousMonth: "الشهر السابق",
        calendarAccessibilityMsg: "من خلال النقر على يوم في التقويم، سيتم عرض أحداث ذلك اليوم",
        eventsOf: "حدث ",
        callPhoneNumber: "Call Phone Number:",
        resetFilters: "إعادة تعيين الفلاتر",
        resaultsFound: "تم العثور على {number} نتيجة",
        showResults: "أظهر النتائج",
        clearEverything: "مسح كل شيء",
        selectFilter: "حدد تصفية",
        removeFromFilters: "قم بإزالة {filterValue} من المرشحات",
        openFiltersSelection: "فتح اختيار المرشحات",
        weAreHere: "نحن هنا",
        apiFetchErrorMsg: "لا يمكن عرض البيانات في الوقت الحالي، يرجى المحاولة مرة أخرى لاحقًا",
        noResultsAtTheTime: "لم يتم العثور على نتائج في هذا الوقت",
        invalidVariableInput: " לא תקין. ניתן להזין רק אותיות, ואת הסימנים .,?!:'-\",% $",
        value: "قيمة",
        category: "فئة",
        chartTabularRepresentation: "تمثيل جدولي للبيانات الموجودة في الرسم البياني.",
        noDataAvailable: "لا توجد بيانات متاحة",
        copyLink: "نسخ الرابط",
        copied: "تم النسخ"
    }
})

Consts.setLanguage(document.documentElement.lang);

export default Consts